<div class="dna-ss-wrap" [class.open]="isOpen" [class.disabled]="disabled">

  <div class="dna-ss-trigger" (click)="toggle()">
    <span class="dna-ss-value" [class.dna-ss-placeholder]="!selectedValue">
      {{selectedValue != null ? selectedLabel : placeholder}}
    </span>
    <span class="material-icons dna-ss-arrow">expand_more</span>
  </div>

  <div class="dna-ss-panel" *ngIf="isOpen">
    <div class="dna-ss-search">
      <span class="material-icons">search</span>
      <input #searchInput type="text" placeholder="Pesquisar..."
        [(ngModel)]="searchTerm" (click)="$event.stopPropagation()">
    </div>
    <div class="dna-ss-list">
      <div class="dna-ss-option"
           *ngFor="let opt of filteredOptions"
           [class.dna-ss-selected]="opt.value == selectedValue"
           (click)="select(opt, $event)">
        {{opt.label}}
      </div>
      <div class="dna-ss-empty" *ngIf="filteredOptions.length === 0">
        Nenhum resultado
      </div>
    </div>
  </div>

</div>
